package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Query
import com.xtream.data_kmp.db.tables.VodCategoryWithVisibleStatus
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodCategoryWithSize
import com.xtream.data_kmp.dto.vodCategoriesTable
import com.xtream.data_kmp.vodsFavoritesTable
import com.xtream.data_kmp.watchedVodStreamsTable
import kotlinx.coroutines.flow.Flow


@Dao
abstract class VodCategoriesDao:RoomBaseInterface<VodCategory> {

    @Query("SELECT * FROM ${vodCategoriesTable} ORDER BY created_at")
    abstract override fun allAsFlow(): Flow<List<VodCategory>>

 /*   @Query("""
        SELECT * FROM ${vodCategoriesTable}
         WHERE CASE
         WHEN categoryId = ${AllConst.FAV_CATEGORIES_ID}
         THEN
            categoryId IN ( SELECT DISTINCT categoryId FROM ${vodsFavoritesTable})
         WHEN categoryId = ${AllConst.WATCHED_CATEGORIES_ID}
         THEN
            categoryId IN ( SELECT DISTINCT categoryId FROM ${watchedVodStreamsTable})
         ELSE
           categoryId IN ( SELECT DISTINCT categoryId FROM vodTable)
         END

ORDER BY created_at 
         """)*/

    @Query("""SELECT * FROM vodCategoriesTable ORDER BY created_at""")
    abstract override fun allAsPagingSource(): PagingSource<Int, VodCategory>



    @Query(
        "SELECT * FROM ${vodCategoriesTable}"
        // +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"

        /*+"ORDER BY sortOrder"*/
    )
    abstract fun getPagedCategories(): PagingSource<Int, VodCategory>


    @Query("SELECT EXISTS (SELECT 1 FROM ${vodCategoriesTable} WHERE categoryId = :id)")

    abstract override suspend fun hasEntity(id: Int): Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM ${vodCategoriesTable} WHERE categoryId = :id)")

    abstract override fun hasEntityAsFlow(id: Int?): Flow<Boolean>

    @Query("SELECT COUNT(*) FROM ${vodCategoriesTable}")
    abstract override suspend  fun getSize(): Long?
    @Query("DELETE FROM vodCategoriesTable")
    abstract override suspend fun deleteAll()


    @Query("""
    SELECT 
    category.*, 
    CASE 
        WHEN category.categoryId = -2 THEN (SELECT COUNT(streamId) FROM ${vodsFavoritesTable})
        WHEN category.categoryId = -3 THEN (SELECT COUNT(streamId) FROM ${watchedVodStreamsTable})
        ELSE (SELECT COUNT(streamId) FROM vodTable WHERE categoryId = category.categoryId)
    END AS size  
FROM vodCategoriesTable AS category
GROUP BY category.categoryId
ORDER BY category.created_at
""")
    abstract fun getPagingCategoriesWithSize(): PagingSource<Int, VodCategoryWithSize>



    @Query("""
    SELECT c.*,
           CASE WHEN h.categoryId IS NULL THEN 0 ELSE 1 END AS isHidden
    FROM vodCategoriesTable c
    LEFT JOIN hidden_categories h
        ON c.categoryId = h.categoryId
       AND h.type = 'MOVIE'
""")
    abstract fun getCategoriesWithVisibleStatus():
            Flow<List<VodCategoryWithVisibleStatus>>

}